import { feedFactoryAxios } from '../lib/axios';

export interface UploadedAsset {
  uri: string;
  fileName: string;
  format: string;
  copyright: string | null;
}

const postAssetPromise = (asset: File) => {
  const formData = new FormData();
  formData.append('file', asset);
  return feedFactoryAxios.post('/assets', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const postAsset = async (asset: File): Promise<UploadedAsset> => {
  const res = await postAssetPromise(asset);
  const data = res.data;

  // The API returns an absolute uri built from its own configured base url.
  // Guard against a relative one so the link stored on the event always
  // resolves for the editors.
  if (data.uri && !/^https?:\/\//i.test(data.uri)) {
    data.uri = new URL(data.uri, window.location.origin).toString();
  }

  return data as UploadedAsset;
};

export const postAssets = async (assets: File[]): Promise<UploadedAsset[]> => {
  return Promise.all(assets.map((asset) => postAsset(asset)));
};
